import { render } from "./AlertMessage.vue?vue&type=template&id=b1bd2b94"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProyectosTrabajo\\MRO_SUITE_DE (RU)\\MRO_IbizaRU\\trunk\\fuentes\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__